export default __webpack_public_path__ + "static/media/home_cryptos.684948c6.png";